import rtkRequestStatusCodes from "../const/rtkRequestStatusCodes";
import { ObjectValueType } from "./utilityTypes/ObjectValueType";

export const LoadingStatusCode = { ...rtkRequestStatusCodes };
export type LoadingStatusCode = ObjectValueType<typeof rtkRequestStatusCodes>;
